import { inject, Injectable } from "@angular/core";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { DicomService } from "src/app/services/dicom.service";
import { PopupService } from "src/app/services/popup/popup.service";
import { sntTranslate } from "src/app/support/translate";

@Injectable()
export class FilePickerService {
  readonly #popupService = inject(PopupService);
  readonly #dicomService = inject(DicomService);

  pickWithNote(
    { file }: { file?: File },
    {
      options
    }: {
      options?: {
        title?: string;
        fileInputAccept?: string;
        fileInputLabel?: string;
        fileInputPlaceHolder?: string;
        dialogWidth?: number;
        dialogHeight?: number;
      };
    }
  ): Promise<{ file: File | null; note?: string }> {
    return new Promise<{ file: File | null; note?: string }>((res) => {
      this.#popupService.createEntity<{
        files: Array<File> | null;
        note?: string;
      }>({
        title: sntTranslate(marker("Seleziona un file")),
        initialFormData: {
          files: file ? [file] : null,
          note: undefined
        },
        modalConfig: {
          dialog: true,
          width: options?.dialogWidth,
          height: options?.dialogHeight
        },
        formItems: [
          {
            dataField: "files",
            // TODO <any> è necessario visto che i typings devextreme non hanno incluso ""
            editorType: <any>"dxFileUploader",
            editorOptions: {
              uploadMode: "useForm",
              accept: options?.fileInputAccept
            },
            label: {
              text: options?.fileInputLabel || sntTranslate(marker("File")),
              location: "top",
              showColon: false
            },
            validationRules: [
              { type: "required" },
              {
                type: "async",
                message: sntTranslate(
                  marker(
                    "Il file ZIP deve contenere almeno un file DICOM (.dcm)"
                  )
                ),
                validationCallback: async ({ value }) => {
                  if (!value || value.length === 0) {
                    return true;
                  }
                  const file: File = value[0];
                  return await this.#dicomService.validateZip({ file });
                }
              }
            ]
          },
          {
            dataField: "note",
            editorType: "dxTextArea",
            editorOptions: {
              height: 128
            },
            label: {
              text: sntTranslate(marker("Note")),
              location: "top",
              showColon: false
            }
          }
        ],
        create: async (formData) => {
          let file: File | null = null;

          if (formData.files && formData.files.length > 0) {
            file = formData.files[0];
          }

          res({
            file,
            note: formData.note
          });
        },
        onCancel: async () => {
          res({ file: null });
        }
      });
    });
  }
}
